




















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {CartStore} from '@/store/modules/cart.store';
import {MenuStore} from '@/store/modules/menu.store';
import {WebService} from '@/services/web.service';
// @ is an alias to /src

@Component({
	components: {}
})
export default class CategoryHeader extends Vue {
	@Prop({required: true})
	menuId!: string;

	@Prop({required: true})
	categoryId!: string;

	@Prop({required: true})
	categoryName!: string;

	private internalCategoryName = '';

	private editing = false;
	showLoading = false;


	created() {
		this.internalCategoryName = this.categoryName;
	}

	@Watch('categoryName', {immediate: true})
	onValueChange() {
		this.internalCategoryName = this.categoryName;
	}

	valueChanged() {
		this.$emit('changed', {
			categoryId: this.categoryId,
			value: this.internalCategoryName
		});
	}

	async deleteCategory() {
		if(await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this category?', {
			centered: true,
			okTitle: 'Delete Category'
		})) {
			try {
				this.showLoading = true;
				await WebService.deleteCategory(this.menuId, this.categoryId);
				this.showLoading = false;
			} catch(e) {
				this.showLoading = false;
				await this.$bvModal.msgBoxOk('There was a problem deleting your category', {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}

		}
	}

	async cancel() {
		this.internalCategoryName = this.categoryName;
		this.editing = false;
	}

	async edit() {
		this.editing = true;
	}

	get menu() {
		return MenuStore.menu(this.menuId);
	}

	get validCategoryName() {
		if(this.menu !== null) {
			return this.internalCategoryName.trim() !== '' && this.menu.categories.map((category) => {
				return category.name.toLowerCase();
			}).indexOf(this.internalCategoryName.trim().toLowerCase()) === -1;
		}
		return false;
	}

	async save() {
		if(!this.validCategoryName) {
			await this.$bvModal.msgBoxOk('Please enter a valid, unique category name', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		} else {
			try {
				this.showLoading = true;
				await WebService.updateCategory(this.menuId, {
					categoryId: this.categoryId,
					name: this.internalCategoryName
				});
				this.showLoading = false;
			} catch(e) {
				this.showLoading = false;
				await this.$bvModal.msgBoxOk('There was a problem editing your category', {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}
		}

	}

}
